// extracted by mini-css-extract-plugin
export var chatHtmlText = "_qd-2";
export var chatLink = "_qd-0";
export var chatText = "_qd-1";